<template>
	<div class="login-bg">
		<Header></Header>
		<div class="login-area">
            
            <div class="login-area-wrapper">
                <div style="background: #fff; padding: 20px;">
                    <LoginRegister
                        :defaultOpening="0"
                        :redirect="true"
                        :redirect-to-login="'/dashboard'">
                    </LoginRegister>
                </div>
                
            </div>
        </div>
		<Footer></Footer>
	</div>
</template>

<script>

import Header from './components/SecondaryHeader.vue'
import Footer from './components/SecondaryFooter.vue'
import LoginRegister from '../components/LoginRegister.vue'
import axios from 'axios'

export default {
	data() {
		return {
            email: null,
            phone: null,
            username: null,
            password: null,
            error: null,
		};
	},
	components: {
		Header,
        Footer,
        LoginRegister
	},
	mounted: function() {
        var vm = this
        
        axios.get('/auth/check').then(results => {  
            if(results.data.type === "success") {
                this.$buefy.toast.open({
                    message: 'You are already logged in!',
                    type: 'is-success', // is-danger
                    duration: 1000,
                    queue: false
                })
                this.$router.push({ path: '/dashboard' })
                
            }
        })
	},
	computed: {
	
	},
	methods: {
        loginAttempt: function() {
            // send username and password via axios to auth
            // if successful, send back just the email address - maybe a few other fields

            var vm = this
            axios.get('https://api.ipify.org/?format=json').then(ip => {
                axios.post('/auth/attempt', {
                    email: vm.email,
                    phone: vm.phone,
                    username: vm.username,
                    password: vm.password,
                    ip: ip.data.ip
                }).then(results => {
                    // spit back results
                    
                    vm.error = null
                    if(results.data.type === "success") {
                        // redirect the user after saving everything to localstorage

                        this.$nextTick(function() {
                            this.$buefy.snackbar.open({
                                message: 'Successfully logged in.',
                                type: 'is-success' // is-danger
                            })
                            this.$router.push({ name: 'Dashboard' })
                            
                        })
                        
                    } else {
                        // display error
                        vm.error = results.data.error

                        this.$buefy.snackbar.open({
                            message: vm.error,
                            type: 'is-danger' // is-danger
                        })
                    }
                    
                })
            })
            
        }
	}
}
</script>

<style lang="scss">
    @import '../../styles/Frontend.scss';
</style>
